import {StringUtil} from 'common/util/StringUtil';
import emojiRegex from 'emoji-regex';

export class FormatterUtil {
    public static trim(raw: string): string {
        return typeof raw === 'string' ? raw.trim() : raw;
    }

    public static capitalize(raw: string): string {
        const lowraw: string = FormatterUtil.lower(raw);

        return typeof lowraw === 'string' ? lowraw.split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : raw;
    }

    public static ucfirst(raw: string): string {
        const lowraw: string = FormatterUtil.lower(raw);

        return typeof lowraw === 'string' ? lowraw.charAt(0).toUpperCase() + lowraw.slice(1) : raw;
    }

    public static lower(raw: string): string {
        return typeof raw === 'string' ? raw.toLocaleLowerCase() : raw;
    }

    public static upper(raw: string): string {
        return typeof raw === 'string' ? raw.toLocaleUpperCase() : raw;
    }

    public static phone(raw: string, locale: string, output: 'nat' | 'int' = 'int'): string {
        if (typeof raw === 'string') {
            raw = FormatterUtil.preformatPhone(raw, locale);
            switch (output) {
                case 'nat': // national
                    return FormatterUtil.phoneNat(raw, locale);
                case 'int': // international
                    return FormatterUtil.phoneInt(raw, locale);
            }
        }

        return raw;
    }

    public static stripEmoji(raw: string): string {
        let output: string = raw;

        if (typeof output === 'string') {
            let match;
            while ((match = emojiRegex().exec(output)) !== null) {
                try {
                    // output = output.replace(new RegExp('\\s' + StringUtil.escapeRegExp(match[0]), 'g'), '');
                    // output = output.replace(new RegExp(StringUtil.escapeRegExp(match[0]) + '\\s', 'g'), '');
                    output = output.replace(new RegExp(StringUtil.escapeRegExp(match[0]), 'g'), '');
                    output = output.replace(new RegExp('\\s+', 'g'), ' ');
                    output = output.trim();
                } catch (_e) {
                    // ignore
                }
            }
        }

        return output;
    }

    public static stripExoticCharacters(raw: string): string {
        if (typeof raw === 'string') {
            return raw.replace('’', '\'').replace(/[\u0250-\ue007]+/g, '*');
        }

        return raw;
    }

    private static preformatPhone(raw: string, locale: string): string {
        raw = raw.trim().replace(/\s?\.?\-?\(?\)?/g, '');
        switch (locale) {
            case 'fr':
                if ((new RegExp('^[1-9]')).test(raw) && raw.length === 9) {
                    return '0' + raw;
                }
                break;
        }

        return raw;
    }

    private static phoneNat(raw: string, locale: string): string {
        switch (locale) {
            case 'fr': // format: 06 11 22 33 44
                if (raw.startsWith('+330')) {
                    raw = raw.substring(3);
                } else if (raw.startsWith('+33')) {
                    raw = '0' + raw.substring(3);
                } else if (raw.startsWith('0033')) {
                    raw = '0' + raw.substring(4);
                } else if (raw.startsWith('33') && raw.length === 11) {
                    raw = '0' + raw.substring(2);
                }

                if (raw.length === 10) {
                    let i: number = 0;
                    raw = raw.split('').map((num) => {
                        i++;

                        return num + (i % 2 === 0 ? ' ' : '');
                    }).join('').trim();
                }

                return raw;
        }

        return raw;
    }

    private static phoneInt(raw: string, locale: string): string {
        if (raw.startsWith('+')) {
            return raw;
        }

        switch (locale) {
            case 'fr': // format: +33611223344
                if (raw.startsWith('0')) {
                    raw = raw.substring(1);
                }

                return '+33' + raw;
        }

        return raw;
    }
}
